import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Text,
  Textarea,
  Flex,
  Select,
  Switch,
  CheckboxGroup,
  Checkbox,
  Stack,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { DEPARTMENTS } from "../../constants/departments";

import TeacherNavTop from "./TeacherNavTop";
import { useDispatch } from "react-redux";
import { addProduct } from "../../Redux/TeacherReducer/action";
import { useNavigate } from "react-router-dom";
import { useModalToast } from "../../context/GlobalModalToast";

const AddTeacherCourse = () => {
  const dispatch = useDispatch();
  const { toast } = useModalToast();
  const navigate = useNavigate();

  let obj = {
    title: "",
    description: "",
    category: "",
    department: "",
    img: "",
    isGlobal: true,
    targetSectors: [],
  };

  const [detail, setDetail] = useState(obj);
  const [categories, setCategories] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [uploadType, setUploadType] = useState("link"); // 'link' or 'file'

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to fetch categories");
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) { // 2MB limit
        toast({ title: "File too large. Max 2MB allowed.", status: "warning" });
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setDetail((prev) => ({ ...prev, img: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };
  const handleSubmit = async () => {
    setErrorMsg("");
    try {
      // Basic client validation first
      if (!detail.title || !detail.category) {
        setErrorMsg("Title and Category are required");
        return;
      }
      
      const res = await dispatch(addProduct(detail));
      if (res && res.error) {
        setErrorMsg(res.message || "Failed to add course");
        return;
      }
      toast({ title: "Course Added Successfully", status: "success", duration: 2000 });
      navigate("/Teacher/courses");
    } catch (e) {
      setErrorMsg(e.message || "Course name already taken or an error occurred.");
    }
  };

  return (
    <Grid className="Nav" h={"99vh"} w="94%" gap={10}>
      <Box mt='80px'>
        <TeacherNavTop />

        <Box border={"2px solid gray"} borderRadius={10} p={10} h="90%">
          {errorMsg && <Text color="red.500" mb={4} fontWeight="bold">{errorMsg}</Text>}
          <FormControl isRequired>
            <FormLabel>Title</FormLabel>
            <Input
              type="text"
              placeholder="Enter Course Title"
              name="title"
              value={detail.title}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Description</FormLabel>
            <Textarea
              placeholder="Enter Course description"
              name="description"
              value={detail.description}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Category</FormLabel>
            <Box as="select" 
              name="category" 
              value={detail.category} 
              onChange={handleChange} 
              w="100%" 
              p={2} 
              border="1px solid" 
              borderColor="inherit" 
              borderRadius="md"
            >
              <option value="">Select a Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat.name}>{cat.name}</option>
              ))}
            </Box>
          </FormControl>
          <FormControl mt={4} isRequired>
            <FormLabel>Department</FormLabel>
            <Select
              placeholder="Select Department"
              name="department"
              value={detail.department}
              onChange={handleChange}
            >
              {DEPARTMENTS.map((dept) => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </Select>
          </FormControl>
          <FormControl mt={4} display="flex" alignItems="center">
            <FormLabel mb="0">Global Training Module (Available to all departments)?</FormLabel>
            <Switch
              isChecked={detail.isGlobal}
              onChange={(e) => setDetail(prev => ({ ...prev, isGlobal: e.target.checked }))}
              colorScheme="purple"
            />
          </FormControl>
          {!detail.isGlobal && (
            <FormControl mt={4}>
              <FormLabel>Select Target Departments</FormLabel>
              <CheckboxGroup
                colorScheme="blue"
                value={detail.targetSectors}
                onChange={(values) => setDetail(prev => ({ ...prev, targetSectors: values }))}
              >
                <Stack spacing={2} direction="row" wrap="wrap">
                  {DEPARTMENTS.map((dept) => (
                    <Checkbox key={dept} value={dept}>{dept}</Checkbox>
                  ))}
                </Stack>
              </CheckboxGroup>
            </FormControl>
          )}
          <FormControl mt={4}>
            <FormLabel>Course Thumbnail (Optional)</FormLabel>
            <Flex gap={4} mb={2}>
              <Button size="sm" variant={uploadType === "link" ? "solid" : "outline"} colorScheme="purple" onClick={() => setUploadType("link")}>Paste Link</Button>
              <Button size="sm" variant={uploadType === "file" ? "solid" : "outline"} colorScheme="purple" onClick={() => setUploadType("file")}>Upload File</Button>
            </Flex>
            {uploadType === "link" ? (
              <Input
                type="text"
                placeholder="Enter Course thumbnail Link (e.g. https://...)"
                name="img"
                value={detail?.img}
                onChange={handleChange}
              />
            ) : (
              <Box border="1px dashed" borderColor="gray.300" p={4} borderRadius="md" textAlign="center">
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                  p={1}
                />
                {detail.img && detail.img.startsWith("data:image") && (
                  <Text mt={2} fontSize="xs" color="green.500">Image selected and ready.</Text>
                )}
              </Box>
            )}
          </FormControl>
          <Button
            mt={8}
            colorScheme="blue"
            size="md"
            w="full"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Grid>
  );
};

export default AddTeacherCourse;
